import React from 'react'
import { HorizontalBar } from 'react-chartjs-2'

export default class RSRLHorizontalBar extends React.Component {
  render() {
    // const feuil1 = this.props.data.allLettersXlsxFeuil1.edges
    // let labels = feuil1.map((row,i) => (row.node.letter))
    // let values = feuil1.map((row,i) => (row.node.value))
    let data = {
      labels: this.props.labels,
      datasets: [
        {
          label: this.props.label,
          data: this.props.values,
          backgroundColor: this.props.backgroundColor,
          barPercentage: 1,
        },
      ],
    }
    let options = {
      legend: {
        display: false,
        position: 'bottom',
        labels: {
          fontSize: 16,
          boxWidth: 40,
          padding: 40,
        },
      },
      tooltips: {
        mode: 'index',
        axis: 'x',
        cornerRadius: 0,
        xPadding: 16,
        yPadding: 16,
        backgroundColor: '#707070',
        // callbacks: {
        //   beforeTitle: function(tooltipItem) {
        //     return this.props.tooltipLabel;
        // }
      },
      scales: {
        xAxes: [
          {
            scaleLabel: {
              display: this.props.xlabel != null,
              labelString: this.props.xlabel,
            },
            stacked: true,
            gridLines: { display: false },
          },
        ],
        yAxes: [
          {
            scaleLabel: {
              display: this.props.ylabel != null,
              labelString: this.props.ylabel,
            },
            stacked: true,
            gridLines: {
              display: true,
              color: '#DADADA',
              lineWidth: 1,
              tickMarkLength: 5,
              borderDash: [2, 2],
            },
            ticks: { display: true },
          },
        ],
      },
    }
    return (
      <div className="graph-wrapper">
        <div className="scroll-area">
          <HorizontalBar data={data} options={options} />
        </div>
      </div>
    )
  }
}
